import TableStructure from 'common/TableStructure';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';


import React, { useState } from 'react';

import StaffMemberPopup from './StaffMemberPopup';

export const GridContainer = styled.div`
    width: 100%;
    overflow-x: auto;
    
    @media (min-width: 768px) {
        overflow-x: visible;
    }
`;

export default function OfficeStaffTable({ rows, getOfficeStaffList }) {
    const [openPopup, setOpenPopup] = useState(false);
    const [editRowData, setEditRowData] = useState({});

    const togglePopup = (params) => {
        setEditRowData(params);
        setOpenPopup(!openPopup);
    };


    const handleSuccess = () => {
        getOfficeStaffList().then();
    };

    const columns = [
        {
            field: 'id',
            headerName: <FormattedMessage id="be.seen.invoice.table.date" defaultMessage="ID" />,
            flex: 0.3,
            minWidth: 60,
        },

        {
            field: 'name',
            headerName: <FormattedMessage id="be.seen.invoice.table.name" defaultMessage="NAME" />,
            flex: 1,
            minWidth: 120,
        },
        {
            field: 'email',
            headerName: <FormattedMessage id="be.seen.invoice.table.name" defaultMessage="EMAIL" />,
            flex: 1,
            minWidth: 150,
        },
        {
            field: 'role',
            headerName: <FormattedMessage id="be.seen.invoice.table.name" defaultMessage="ROLE" />,
            flex: 0.7,
            minWidth: 100,
        },

        {
            field: '',
            headerName: '',
            sortable: false,
            flex: 0.3,
            minWidth: 50,
            renderCell: (params) => {
                return (
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                            cursor: 'pointer',
                            marginLeft: 'auto',
                            marginRight: '12px',
                        }}
                    >
                        <path
                            d="M9 18L15 12L9 6"
                            stroke="#666666"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                );
            },
        },
    ];
    return (
        <>
            <GridContainer>
                <TableStructure rows={rows} columns={columns} handleRowClick={togglePopup}></TableStructure>
            </GridContainer>
            <StaffMemberPopup
                open={openPopup}
                onClose={togglePopup}
                staffData={editRowData}
                getOfficeStaffList={getOfficeStaffList}
            ></StaffMemberPopup>
        </>
    );
}
